import { SECTION_OVERVIEW } from "common/routes/sections/main.sections";

export const OVERVIEW_URL = `/${SECTION_OVERVIEW.path}`;

export const OVERVIEW = {
  path: "",
  params: "",
  subtitle: "Overview",
  title: "Dashboard",
  withStepper: false,
  withDate: true,
};

export const OVERVIEW_BUDGET = {
  path: "budget/",
  params: ":scenarioId?/",
  backTo: OVERVIEW_URL,
  subtitle: "Project Status",
  title: "",
  withStepper: false,
  withDate: true,
};
